export function formatPercent(value) {
  return `${Number(value).toFixed(2)}%`
}

export function formatNumber(value) {
  return Number(value).toLocaleString('zh-TW')
}

export function formatFetchedAt(value) {
  if (!value) return '--'
  return new Intl.DateTimeFormat('zh-TW', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(value))
}

export function formatDelta(cell) {
  if (cell.status === 'newHolding') {
    return '新增'
  }
  if (cell.delta == null) {
    return '--'
  }

  const sign = cell.delta > 0 ? '+' : ''
  if (cell.metric === 'weight') {
    return `${sign}${cell.delta.toFixed(2)}%`
  }
  return `${sign}${formatNumber(cell.delta)}`
}
